import type { ReactNode } from 'react';
import { ButtonIconText } from './ButtonIconText';
import type { SearchBoxProps } from './SearchBox';
import { SearchBox } from './SearchBox';

export interface TableToolbarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchBoxProps?: Omit<SearchBoxProps, 'value' | 'onChange'>;
  onAdd: () => void;
  addLabel: string;
  children?: ReactNode;
}

export function TableToolbar({
  searchValue,
  onSearchChange,
  searchBoxProps,
  onAdd,
  addLabel,
  children,
}: TableToolbarProps) {
  return (
    <div className="grid md:grid-cols-2 gap-y-2 md:gap-y-0 md:gap-x-5">
      <div className="flex flex-col gap-2">
        <SearchBox value={searchValue} onChange={onSearchChange} {...searchBoxProps} />
      </div>

      <div className="flex flex-wrap md:justify-end items-center gap-2">
        {children}

        <ButtonIconText
          iconName="plus"
          onClick={onAdd}
          className='sm:content-center'
          aria-label={addLabel}
        >
          {addLabel}
        </ButtonIconText>
        {/* <button
          type="button"
          onClick={onAdd}
          className="py-2 px-3 inline-flex items-center gap-x-1.5 text-sm font-medium rounded-lg bg-primary text-onprimary shadow-2xs hover:bg-primary-darker disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <Plus className="shrink-0 size-4" />
          {addLabel}
        </button> */}
      </div>
    </div>
  );
}
